import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../Shared/Icons';

// ── Jinsi ya Kucheza — mwongozo kamili wa Iyanna Chess ─────────────────
const SECTIONS = [
  {
    icon: 'user',
    title: '1. Kuingia Kwenye Chess',
    steps: [
      'Fungua iyannafoundationtz.org kisha bofya "Chess App" (au nenda moja kwa moja /chess).',
      'Andika jina lako la mchezo (nickname) — chagua jina lolote unalolipenda.',
      'Bofya "Ingia Lobby" — uko ndani! Jina lako na rating yako ya kuanzia (1200) vinaonekana juu.',
    ],
  },
  {
    icon: 'clock',
    title: '2. Chagua Muda wa Mchezo',
    steps: [
      'Kabla ya kuanza mchezo, chagua muda kwenye "Chagua Muda": 1, 3, 5, 10, 15 au 30 dakika.',
      'Bullet (1 min) = kasi ya umeme. Blitz (3-5 min) = haraka. Rapid (10-15 min) = wastani. Classical (30 min) = utulivu kamili.',
      'Kila mchezaji anapata muda huo; saa yako inapungua tu wakati wa zamu YAKO.',
      'Muda ukiisha kabla ya mpinzani — umeshindwa kwa "timeout". Chagua muda unaokufaa!',
    ],
  },
  {
    icon: 'bot',
    title: '3. Kucheza na Bot (Mazoezi)',
    steps: [
      'Bofya "Play vs Bot" — unaanza mara moja, hakuna kusubiri mtu.',
      'Bot inajipima na kiwango CHAKO: ukiwa mwanzo inacheza pole pole, ukikua inakuwa ngumu zaidi.',
      'Una "Hint" 3 kila mchezo — Coach anakupendekezea move nzuri ukikwama.',
      '"Undo Move" ipo pia — umekosea? Rudisha move yako bila adhabu. Ni mazoezi!',
    ],
  },
  {
    icon: 'bolt',
    title: '4. Kucheza na Watu (Online)',
    steps: [
      '"Play Random" — unatengeneza mchezo wa wazi; mtu yeyote kwenye lobby anaweza kujiunga nawe.',
      '"Private Game" — unapata CODE ya siri (mfano: A1B2C3). Mtumie rafiki yako, yeye anabofya "Join with Code" na kuiandika — mnacheza wawili tu.',
      'Unaweza pia ku-copy link ya mchezo na kuituma WhatsApp — rafiki akibofya anaingia moja kwa moja.',
      'Wakati wa mchezo: Offer Draw (pendekeza sare), Request Takeback (omba kurudisha move), Resign (jisalimishe), Flip Board (geuza ubao).',
    ],
  },
  {
    icon: 'trophy',
    title: '5. Rating na Top Players',
    steps: [
      'Kila mchezo wa watu wawili unabadilisha rating yako: ukishinda inapanda, ukishindwa inashuka (kidogo tu ukiwa mwanzo — usiogope kucheza!).',
      'Ngazi za Kiswahili: Mchipukizi (0) → Swala (300) → Twiga (700) → Tembo (1200) → Chui (1800) → Simba (2400).',
      'Kucheza kwenye mashindano au chess club kunaongeza pointi za ziada kila mchezo — hata ukishindwa. Hii ndiyo maana mchezaji anayehudhuria sana anapanda haraka kuliko anayecheza peke yake.',
      'Hii ni RATING YA MAZOEZI — inahamasisha watu kucheza. Kwa rating rasmi inayotokana na mashindano yaliyothibitishwa pekee, ona ukurasa wa "Rating Rasmi (IFR)".',
      'Orodha ya "Top Players — Wachezaji Bora" ipo kwenye Lobby — wachezaji 10 bora na medali za dhahabu, fedha na shaba.',
      'Cheza mara kwa mara, panda ngazi, jina lako lionekane kwenye orodha ya mabingwa!',
    ],
  },
  {
    icon: 'puzzle',
    title: '6. Puzzle ya Kila Siku',
    steps: [
      'Bofya "Daily Puzzle" kwenye Lobby — kila siku kuna fumbo jipya la chess.',
      'Tazama ubao, fikiri, kisha cheza move sahihi inayoshinda.',
      'Ukitatua kila siku mfululizo, "streak" yako inakua — usikate mnyororo!',
    ],
  },
  {
    icon: 'book',
    title: '7. Jifunze Chess (Kwa Wapya Kabisa)',
    steps: [
      'Hujui chess kabisa? Bofya "Jifunze Chess" kwenye Lobby.',
      'Utajifunza jinsi kila kipande kinavyotembea: Askari, Ngamia, Farasi, Ngome, Malkia na Mfalme.',
      'Kisha ujifunze Check, Checkmate na jinsi ya kushinda — halafu kaanze na Bot!',
    ],
  },
  {
    icon: 'flag',
    title: '8. Mashindano (Tournaments)',
    steps: [
      'Bofya "Tournaments" kwenye Lobby kuona mashindano yaliyopo.',
      'Jiunge na shindano lililo wazi — utapangwa na wapinzani kila raundi (Swiss system).',
      'Pointi: Ushindi = 1, Sare = 0.5, Kushindwa = 0. Mwenye pointi nyingi mwishoni ndiye bingwa!',
    ],
  },
  {
    icon: 'sparkle',
    title: '9. Somo la Maisha',
    steps: [
      'Kila mchezo ukiisha, Iyanna Chess inakupa "Somo la Maisha" — funzo linalounganisha chess na maisha halisi.',
      'Uvumilivu, kufikiri kabla ya kutenda, kusimama tena baada ya kushindwa — chess ni darasa la maisha.',
      'Hii ndiyo tofauti ya Iyanna Chess: hatukufundishi mchezo tu, tunakujenga wewe.',
    ],
  },
];

export default function ChessGuide() {
  const navigate = useNavigate();
  return (
    <div style={styles.page}>
      <div style={styles.topBar}>
        <Link to="/chess" style={styles.backLink}>← Rudi Lobby</Link>
      </div>

      <div style={styles.bar}>
        <button style={styles.backIconBtn} onClick={() => navigate('/chess')}>
          <Icon name="door" size={19} color="#ECEFEA" strokeWidth={2.4} />
        </button>
        <div style={styles.barTitle}>Mwongozo</div>
        <div style={{ width: '38px' }} />
      </div>

      <div style={styles.sections}>
        {SECTIONS.map((sec, i) => (
          <div key={i} style={styles.card}>
            <div style={styles.cardHead}>
              <div style={styles.cardIcon}>
                <Icon name={sec.icon} size={20} color="#4ADE80" />
              </div>
              <div style={styles.cardTitle}>{sec.title}</div>
            </div>
            <ol style={styles.stepList}>
              {sec.steps.map((st, j) => (
                <li key={j} style={styles.step}>{st}</li>
              ))}
            </ol>
          </div>
        ))}
      </div>

      <div style={styles.ctaBox}>
        <div style={styles.ctaText}>Uko tayari? Twende!</div>
        <Link to="/chess" style={styles.ctaBtn}>
          Anza Kucheza Sasa →
        </Link>
      </div>
    </div>
  );
}

const styles = {
  bar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' },
  backIconBtn: { width: '38px', height: '38px', borderRadius: '11px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.09)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  barTitle: { color: '#ECEFEA', fontFamily: "'Fraunces', Georgia, serif", fontSize: '19px', fontWeight: '800' },

  page: { minHeight: '100vh', background: 'radial-gradient(circle at 30% 0%, #262D2A 0%, #1B201E 48%, #121614 100%)', padding: '18px 16px 50px' },
  topBar: { maxWidth: '760px', margin: '0 auto 8px' },
  backLink: { color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '13px', fontWeight: '600' },
  header: { maxWidth: '760px', margin: '10px auto 24px', textAlign: 'center' },
  logoWrap: { width: '64px', height: '64px', borderRadius: '50%', overflow: 'hidden', margin: '0 auto 14px', border: '2px solid rgba(255,255,255,0.15)' },
  logoImg: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
  title: { fontFamily: "'Fraunces', Georgia, serif", fontSize: 'clamp(22px, 5vw, 30px)', color: '#fff', fontWeight: '700', marginBottom: '8px' },
  subtitle: { fontSize: '13.5px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.6, maxWidth: '460px', margin: '0 auto' },
  sections: { maxWidth: '760px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '14px' },
  card: { background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', padding: '18px 20px' },
  cardHead: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' },
  cardIcon: { width: '40px', height: '40px', borderRadius: '11px', background: 'rgba(74,222,128,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  cardTitle: { fontFamily: "'Fraunces', Georgia, serif", fontSize: '17px', color: '#fff', fontWeight: '700' },
  stepList: { margin: 0, paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px' },
  step: { fontSize: '13.5px', color: 'rgba(255,255,255,0.78)', lineHeight: 1.7 },
  ctaBox: { maxWidth: '760px', margin: '28px auto 0', textAlign: 'center' },
  ctaText: { fontFamily: "'Fraunces', Georgia, serif", fontSize: '19px', color: '#fff', marginBottom: '14px' },
  ctaBtn: { display: 'inline-block', background: 'linear-gradient(135deg, #10B981, #34D399)', color: '#fff', textDecoration: 'none', padding: '14px 32px', borderRadius: '12px', fontSize: '15px', fontWeight: '800', boxShadow: '0 8px 24px rgba(16,185,129,0.35)' },
};
